import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard } from '@fortawesome/pro-regular-svg-icons/faIdCard';
import { observer } from 'mobx-react-lite';

import { useDependencies } from '../../dependencies';

export const VerificationHeader = observer((): JSX.Element => {
  const { t } = useTranslation();
  const { stores } = useDependencies();
  const { verification } = stores;
  const getHeader = (): string => {
    if (verification.stripeFailed()) {
      return t('identityCheck.stripeVerification.verificationFailed.header');
    }
    if (verification.stripeInProgress()) {
      if (verification.stripeRequiresInput()) {
        return t('identityCheck.stripeVerification.inProgressRequiresInput.header');
      }
      return t('identityCheck.stripeVerification.inProgressRequiresNoInput.header');
    }

    return t('identityCheck.identityCheck');
  }
  const getDescription = (): string => {
    if (verification.stripeFailed()) {
      return '';
    }
    if (!verification.stripeInProgress()) {
      return t('identityCheck.stripeVerification.notInProgress.description');
    } if (verification.stripeInProgress()) {
      if (verification.stripeRequiresInput()) {
        return t('identityCheck.stripeVerification.inProgressRequiresInput.description');
      }
      return t('identityCheck.stripeVerification.inProgressRequiresNoInput.description');
    }

    return '';
  }

  return (
    <div>
      <div className='font-bold text-xl mb-5'><FontAwesomeIcon icon={faIdCard} /> {getHeader()}</div>
      {!verification.stripeInProgress() && !verification.stripeFailed() &&
        (<div>{t('identityCheck.stripeVerification.notInProgress.header')}</div>)}
      <div className='mb-4'>{getDescription()}</div>
    </div>
  );
});
